import {
  BrowserRouter,
  Routes,
  Route,
  unstable_HistoryRouter as HistoryRouter,
  redirect,
  Navigate,
} from 'react-router-dom';
import axios from './plugins/axios';
import { firstRegistrationEnabled, tenant } from './brand/tenant';
import { CAR_ORIGIN_TYPES } from './constants/carOrigin';
import { useDispatch, useSelector } from 'react-redux';
import { setPermissions, setUser } from './store/user';

// components
import Layout from './components/Layout';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { apiUrl, localApiUrl, FULL_PAYMENT_TYPE_IDS } from './constants/index';

// pages
import Auth from './pages/Auth/Auth';
import Payments from './pages/Payments/Payments';
import Cars from './pages/Car/Cars';
import Profile from './pages/Profile/Profile';
import Deals from './pages/Deal/Deals';
import DealMainInfo from './pages/Deal/DealMainInfo';
import DealNavigation from './pages/Deal/DealNavigation';
import DealAutos from './pages/Deal/DealAutos';
import DealEquipments from './pages/Deal/DealEquipments';
import DealServices from './pages/Deal/DealServices';
import DealHistory from './pages/Deal/DealHistory';
import DealDocs from './pages/Deal/DealDocs';
import NewDealAuto from './pages/Deal/NewDeal/NewDealAuto';
import NewDealEqupment from './pages/Deal/NewDeal/NewDealEqupment';
import NewDealDocs from './pages/Deal/NewDeal/NewDealDocs';
import NewDealService from './pages/Deal/NewDeal/NewDealService';
import Leads from './pages/Leads/Leads';
import LeadMainInfo from './pages/Leads/LeadMainInfo';
import LeadDealInfo from './pages/Leads/LeadDealInfo';
import LeadClient from './pages/Leads/LeadClient';
import LeadsNavigation from './pages/Leads/LeadsNavigation';
import LeadCreate from './pages/Leads/NewLead/LeadCreate';
import NewLeadClient from './pages/Leads/NewLead/NewLeadClient';
import Reports from './pages/Reports/Reports';
import ReportCreate from './pages/Reports/NewReport/ReportCreate';
import Records from './pages/Records/Records';
import RecordService from './pages/Records/RecordService';
import AddRecordService from './pages/Records/NewRecord/AddRecordService';
import AddRecordTestdrive from './pages/Records/NewRecord/AddRecordTestdrive';
import ServiceRecords from './pages/Records/ServiceRecords';
import TestDriveRecords from './pages/Records/TestDriveRecords';
import Clients from './pages/Client/Clients';
import ClientMainData from './pages/Client/ClientMainData/ClientMainData';
import ClientDocs from './pages/Client/ClientDocs';
import ClientDeals from './pages/Client/ClientDeals';
import ClientRecords from './pages/Client/ClientRecords';
import ClientCreate from './pages/Client/NewClient/ClientCreate/ClientClreate';
import ClientCreatePkb from './pages/Client/NewClient/ClientCreatePkb/ClientCreatePkb';
import NewClientsDocs from './pages/Client/NewClient/NewClientsDocuments';
import ClientsNavigation from './pages/Client/ClientsNavigation';
import NewClientDeals from './pages/Client/NewClient/NewClientsDeal';
import NewClientsRecord from './pages/Client/NewClient/NewClientsRecord';
import Equipments from './pages/Equipments/Equipments';
import AddEquipments from './pages/Equipments/AddEquipments';
import Services from './pages/Services/Services';
import AddService from './pages/Services/AddService';
import CarRoutes from './pages/Car/CarRoutes';
import LeadEdit from './pages/Leads/LeadEdit';
import ClientNotary from './pages/NotaryPages/ClientNotary';
import DealNotary from './pages/NotaryPages/DealNotary';
import { store } from '.';
import Permissions from './pages/Settings/Permissions/Permissions';
import { useEffect, useState } from 'react';
import getRoles from './api/roles/getRoles';
import historyObject from './utils/historyObject';
import DealCredits from './pages/Deal/DealCredits';
import DealCreate from './pages/Deal/DealCreate/DealCreate';
import Sign from './pages/Public/Sign';
import LogRocket from 'logrocket';
import EditEquipment from './pages/Equipments/EditEquimpent';
import EditService from './pages/Services/EditService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToasyifyRewrite.css';
import warning from './assets/warning.svg';
import NotaryClientsNavigation from './pages/NotaryPages/Client/NotaryClientsNavigation';
import NotaryClients from './pages/NotaryPages/Client/NotaryClients';
import isUserHaveRole from './utils/isUserHaveRole';
import { ROLE_NOTARY, ROLE_FINANCE } from './constants/roles';
import Loader from './components/Loader/Loader';
import NotaryDeals from './pages/NotaryPages/Deal/NotaryDeal';
import NotaryDealNavigation from './pages/NotaryPages/Deal/NotaryDealNavigation';
import NotaryDealsCredit from './pages/NotaryPages/Deal/NotaryDealCredit';
import DealCreateSellEquipment from './pages/Deal/DealCreate/SellEquipment/DealCreateSellEquipment';
import SignDocuments from './pages/Public/SignDocuments';
import SignTripartite from './pages/Public/SignTripartite';
import History from './pages/document/History';
import DeleteAccount from './pages/Public/DeleteAccount';
import GlobalErrorModal from './helpers/GlobalErrorModal';
import PurchaseRecords from './pages/Records/PurchaseRecords';
import AddRecordPurchase from './pages/Records/NewRecord/AddRecordPurchase';
import DkpSign from './pages/DkpSign/DkpSign';
import StockUpload from './pages/StockUpload/StockUpload';
import PriceList from './pages/PriceList/PriceList';
import StockReport from './pages/StockReport/StockReport';
import StockCars from './pages/StockCars/StockCars';
import VinBlacklist from './pages/VinBlacklist/VinBlacklist';
import VinBlacklistCars from './pages/VinBlacklist/VinBlacklistCars';
import VinBlacklistNavigation from './pages/VinBlacklist/VinBlacklistNavigation';
import ConnectionStatus from './components/ConnectionStatus/ConnectionStatus';
import { OnboardingProvider } from './components/Onboarding/OnboardingProvider';

const uri = localApiUrl + '/';
export let socket = new HubConnectionBuilder()
  .withUrl(uri + 'api/connectCrm')
  .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
  .build();
function App() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  let id = 0;
  async function checkAuthenticate() {
    if (window.location.pathname === '/sign' || window.location.pathname.includes('signDocuments') || window.location.pathname.includes('signTripartite') || window.location.pathname.includes('document/history') || window.location.pathname.includes('delete-account')) {
      return setLoading(false);
    }
    await axios
      .get('/api/user?time=' + new Date().getTime())
      .then((res) => {
        dispatch(setUser({ ...res.data }));
        id = res.data.id;

        LogRocket.identify(res?.data?.id, {
          name: res?.data?.name + ' ' + res?.data?.surname,
          ...res?.data,
        });
      })
      .finally(() => setLoading(false));
    getRoles().then((res) => {
      dispatch(setPermissions(res.data));
    });
  }

  useEffect(() => {
    const startSocket = async () => {
      try {
        await socket.start();
        socket.invoke('connection', id);
      } catch (err) {
        console.error('Socket connection error:', err);
        setTimeout(startSocket, 5000);
      }
    };
    
    if (socket.state === 'Disconnected') {
      startSocket();
    }
    
    socket.onreconnected(() => {
      socket.invoke('connection', id);
    });
  }, [id]);

  useEffect(() => {
    checkAuthenticate();
    getRoles().then((res) => {
      dispatch(setPermissions(res.data));
    });
    socket.on('listenToChangeDealStatus4', (data) => {
      console.log('testsock');
    });
  }, [dispatch]);

  useEffect(() => {
    LogRocket.init('kpwwdu/doscar');
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <HistoryRouter history={historyObject}>
        {/* ÐÐ±ÑÑÐµÐ½Ð¸Ðµ Ð½Ð¾Ð²Ð¸ÑÐºÐ° Ð¶Ð¸Ð²ÑÑ Ð²Ð½ÑÑÑÐ¸ ÑÐ¾ÑÑÐµÑÐ°: ÐµÐ¼Ñ Ð½ÑÐ¶ÐµÐ½ Ð°Ð´ÑÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ. */}
        <OnboardingProvider>
        <Routes>
          <Route path="/sign" element={<Sign />} />
          <Route path="/signDocuments/:clientId/:signUrl/:signType" element={<SignDocuments />} />
          <Route path="/signTripartite" element={<SignTripartite />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/document/history/:documentId" element={<History />} />
          <Route path="/authorization" element={<Auth />} />
          <Route path="/poles/:id/payment" element={<Payments />} />
          <Route path="/" element={<Layout />}>
            {isUserHaveRole(ROLE_NOTARY) && <Route index element={<Navigate to="/notary/clients" />} />}
            {isUserHaveRole(ROLE_FINANCE) && <Route index element={<Navigate to="/reports" />} />}
            {!isUserHaveRole(ROLE_NOTARY) && !isUserHaveRole(ROLE_FINANCE) && <Route index element={<Clients />} />}
            <Route path="leads" element={<Leads />} />
            {/* Ð¡Ð´ÐµÐ»ÐºÐ¸ Halyk Market Ð»ÐµÐ¶Ð°Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ²Ð¾ÑÐ¼ ÑÐ°Ð·Ð´ÐµÐ»Ðµ, Ð² Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ ÑÐ¿Ð¸ÑÐºÐ°Ñ Ð¸Ñ Ð½ÐµÑ. */}
            <Route path="deals" element={<Deals routerParams={{ halykMarket: false }} />} />
            <Route path="deals-rejected" element={<Deals routerParams={{ statusId: 23, halykMarket: false }}/>} />
            {/* Ð£ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ (JetQ) Ð¿ÑÐ¾Ð´Ð°Ð¶ Ð½Ð¾Ð²ÑÑ Ð½ÐµÑ â ÑÑÐ°ÑÐ°Ñ ÑÑÑÐ»ÐºÐ° Ð²ÐµÐ´ÑÑ Ð² Â«ÐÐ£ Ð°Ð²ÑÐ¾Â». */}
            <Route
              path="deals/new"
              element={
                tenant?.usedCarsOnly ? (
                  <Navigate to="/deals/used" replace />
                ) : (
                  <Deals key="deals-new" title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸ Ð½Ð¾Ð²ÑÑ Ð°Ð²ÑÐ¾" routerParams={{ used: false, halykMarket: false }} />
                )
              }
            />
            <Route
              path="deals/halyk"
              element={<Deals key="deals-halyk" title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸ Halyk Market" routerParams={{ halykMarket: true }} />}
            />
            {/* ÐÐ°ÑÐ²ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸Ð» ÑÐ°Ð¼ Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ. Ð­ÑÐ¾ Ð¾Ð±ÑÑÐ½ÑÐµ
                Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¸Ð· Â«ÐÐ¾Ð²ÑÑ Ð°Ð²ÑÐ¾Â» Ð¸ Â«ÐÐ£ Ð°Ð²ÑÐ¾Â» Ð¾Ð½Ð¸ Ð½Ð¸ÐºÑÐ´Ð° Ð½Ðµ Ð¸ÑÑÐµÐ·Ð°ÑÑ â
                ÑÐ°Ð·Ð´ÐµÐ» Ð¿ÑÐ¾ÑÑÐ¾ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ Ð¸Ñ Ð² Ð¾Ð´Ð½Ð¾Ð¼ Ð¼ÐµÑÑÐµ. */}
            <Route
              path="deals/app"
              element={<Deals key="deals-app" title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸ Ð¸Ð· Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ" routerParams={{ fromApp: true }} />}
            />
            {/* ÐÐ¾ÐºÑÐ¿ÐºÐ¸ Ð·Ð° Ð¿Ð¾Ð»Ð½ÑÑ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ, Ð±ÐµÐ· ÐºÑÐµÐ´Ð¸ÑÐ°: Ð¿ÑÐµÐ´Ð¾Ð¿Ð»Ð°ÑÐ° (1), Ð¿Ð¾ ÑÑÑÑÑ (4) Ð¸ ÐºÐ°ÑÑÐ¾Ð¹ (5).
                ÐÐ°ÑÐ²ÐºÐ¸ Ð¸Ð· Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ (Ð±ÑÐ¾Ð½Ñ Ð´Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°) Ð¿Ð¾Ð¿Ð°Ð´Ð°ÑÑ ÑÑÐ´Ð° Ð¶Ðµ. */}
            <Route
              path="deals/full-payment"
              element={
                <Deals
                  key="deals-full-payment"
                  title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸ Ñ Ð¿Ð¾Ð»Ð½Ð¾Ð¹ Ð¾Ð¿Ð»Ð°ÑÐ¾Ð¹"
                  routerParams={{ paymentTypeIds: JSON.stringify(FULL_PAYMENT_TYPE_IDS), halykMarket: false }}
                />
              }
            />
            {/* ÐÐ¾ÑÑÑÐµÐ½Ð¸Ðµ Ñ Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¹ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸ÐµÐ¹ â ÑÐ°Ð·Ð´ÐµÐ» ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð² (tenant). */}
            {firstRegistrationEnabled() && (
              <Route
                path="deals/first-registration"
                element={
                  <Deals
                    key="deals-first-registration"
                    title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸: Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ"
                    routerParams={{ originCarId: CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG, halykMarket: false }}
                  />
                }
              />
            )}
            <Route path="deals/used" element={<Deals key="deals-used" title="ÐÑÐ¾Ð´Ð°Ð¶Ð¸ ÐÐ£ Ð°Ð²ÑÐ¾" routerParams={{ used: true, halykMarket: false }} />} />
            <Route path="cars" element={<Cars />} />
            <Route path="profile" element={<Profile />} />
            <Route path="client" element={<ClientsNavigation />}>
              <Route path=":id/main-data" element={<ClientMainData />} />
              <Route path=":id/documents" element={<ClientDocs />} />
              <Route path=":id/deals" element={<ClientDeals />} />
              <Route path=":id/records" element={<ClientRecords />} />
              <Route path="create" element={<ClientCreate />} />
              <Route path="create-pkb" element={<ClientCreatePkb />} />
              <Route path="documents" element={<NewClientsDocs />} />
              <Route path="deals" element={<NewClientDeals />} />
              <Route path="records" element={<NewClientsRecord />} />
            </Route>
            <Route path="leads" element={<LeadsNavigation />}>
              <Route path="create" element={<LeadCreate />} />
              <Route path="client" element={<NewLeadClient />} />
              <Route path="lead/:id/main-info" element={<LeadMainInfo />} />
              <Route path="lead/:id/client" element={<LeadClient />} />
              <Route path="lead/:id/deal-info" element={<LeadDealInfo />} />
              <Route path="lead/edit/:id" element={<LeadEdit />} />
            </Route>
            <Route path="deals" element={<DealNavigation />}>
              <Route path="deal/:id/main-info" element={<DealMainInfo />} />
              <Route path="deal/:id/autos" element={<DealAutos />} />
              <Route path="deal/:id/equipments" element={<DealEquipments />} />
              <Route path="deal/:id/services" element={<DealServices />} />
              <Route path="deal/:id/documents" element={<DealDocs />} />
              <Route path="deal/:id/history" element={<DealHistory />} />
              <Route path="deal/:id/credit" element={<DealCredits />} />
              <Route path="autos" element={<NewDealAuto />} />
              <Route path="equipments" element={<NewDealEqupment />} />
              <Route path="documents" element={<NewDealDocs />} />
              <Route path="services" element={<NewDealService />} />
            </Route>
            <Route path="deals/create" element={<DealCreate />} />
            <Route path="deals/equipment" element={<DealCreateSellEquipment />} />
            <Route path="cars/*" element={<CarRoutes />} />
            <Route path="equipments" element={<Equipments />} />
            <Route path="equipments/:id" element={<EditEquipment />} />
            <Route path="equipments/add-equipment" element={<AddEquipments />} />
            <Route path="services" element={<Services />} />
            <Route path="services/add-service" element={<AddService />} />
            <Route path="services/:id" element={<EditService />} />
            <Route path="records" element={<Records />} />
            <Route path="records/add-record-service" element={<AddRecordService />} />
            <Route path="records/add-record-testdrive" element={<AddRecordTestdrive />} />
            <Route path="records/add-record-purchase" element={<AddRecordPurchase />} />
            <Route path="records/service" element={<ServiceRecords />} />
            <Route path="records/test-drive" element={<TestDriveRecords />} />
            <Route path="records/test-drive/:id" element={<RecordService />} />
            <Route path="records/service/:id" element={<RecordService />} />
            <Route path="records/purchase" element={<PurchaseRecords />} />
            <Route path="records/purchase/:id" element={<RecordService />} />
            <Route path="reports" element={<Reports />} />
            <Route path="reports/create" element={<ReportCreate />} />

            <Route path="settings">
              <Route path="permissions" element={<Permissions />} />
            </Route>

            <Route path="notary">
              <Route path="clients" element={<NotaryClientsNavigation />}>
                <Route path="" element={<NotaryClients />} />
                <Route path=":id/main-data" element={<ClientNotary />} />
              </Route>
              <Route path="deals" element={<NotaryDealNavigation />}>
                <Route path="" element={<NotaryDeals />} />
                <Route path="prepayment" element={<NotaryDeals />} />
                <Route path="credit" element={<NotaryDealsCredit />} />
                <Route path=":id/main-info" element={<DealNotary />} />
              </Route>
            </Route>
            <Route path="dkp-sign" element={<DkpSign />} />
            <Route path="stock-upload" element={<StockUpload />} />
            <Route path="stock-report" element={<StockReport />} />
            <Route path="stock-cars" element={<StockCars />} />
            <Route path="price-list" element={<PriceList />} />
            {/* Ð§ÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº VIN â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ; Ð±ÑÐº Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ ÑÐ¾Ð»Ñ ÑÐ°Ð¼ */}
            <Route path="vin-blacklist" element={<VinBlacklistNavigation />}>
              <Route index element={<VinBlacklist />} />
              <Route path="cars" element={<VinBlacklistCars />} />
            </Route>
          </Route>
        </Routes>
        </OnboardingProvider>
      </HistoryRouter>
      <ToastContainer
        position="top-center"
        style={{
          maxWidth: 700,
          width: '100%',
        }}
        icon={<img src={warning} alt="Icon" />}
        hideProgressBar
        autoClose={10000}
      />
      <GlobalErrorModal />
      <ConnectionStatus socket={socket} />
    </>
  );
}
export default App;

